import { Bug, GitBranch, MonitorUp, Rss } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { Acesso, Audiencia, Funcionalidade } from '@/data/types';
import { CAPABILITY_ADMIN, CAPABILITY_MAINTAINER, CAPABILITY_PAINEL, temCapability } from '@/lib/capabilities';

/** Staff (admin/maintainer/painel/sysadmin): nunca é bloqueado nem tem funcionalidade escondida. */
export function ehStaff(roles: string[]): boolean {
  return [CAPABILITY_ADMIN, CAPABILITY_MAINTAINER, CAPABILITY_PAINEL].some((role) => temCapability(roles, role));
}

export const ACESSO_LIBERADO: Acesso = { feed: true, ramos: true, incidentes: true, painel: true };

export const MENSAGEM_INDISPONIVEL = 'Esta área não está disponível para o seu perfil.';

export interface InfoFuncionalidade {
  id: Funcionalidade;
  rotulo: string;
  descricao: string;
  icone: LucideIcon;
}

export const INFO_FUNCIONALIDADES: InfoFuncionalidade[] = [
  { id: 'feed', rotulo: 'Feed', descricao: 'A lista de versões publicadas pelo Jenkins.', icone: Rss },
  { id: 'ramos', rotulo: 'Ramos', descricao: 'As versões agrupadas por sprint (2602, 2701…).', icone: GitBranch },
  { id: 'incidentes', rotulo: 'Incidentes', descricao: 'Bugs conhecidos por versão e os selos de alerta.', icone: Bug },
  {
    id: 'painel',
    rotulo: 'Painel do cliente',
    descricao: 'Publicar uma versão como a recomendada no painel do cliente',
    icone: MonitorUp,
  },
];

export const ROTULO_AUDIENCIA: Record<Audiencia, string> = {
  publico: 'Público',
  colaboradores: 'Colaboradores',
  oculto: 'Oculto',
};

export const DESCRICAO_AUDIENCIA: Record<Audiencia, string> = {
  publico: 'Qualquer usuário autenticado vê, inclusive cliente externo.',
  colaboradores: 'Só quem tem e-mail @nasajon.com.br vê.',
  oculto: 'Ninguém vê, exceto quem opera o sistema (administradores, mantenedores e quem publica no painel).',
};

export function rotuloDaFuncionalidade(id: string): string {
  return INFO_FUNCIONALIDADES.find((item) => item.id === id)?.rotulo ?? id;
}

/** "funcionalidade:feed" -> "Funcionalidade Feed"; "ramo:instalador-erp:2602" -> "Ramo 2602". */
export function rotuloDoAlvo(alvo: string, nomeProduto: (produto: string) => string): string {
  const [tipo, ...resto] = alvo.split(':');
  if (tipo === 'funcionalidade') return `Funcionalidade ${rotuloDaFuncionalidade(resto.join(':'))}`;
  if (tipo === 'ramo') {
    const [produto, ...ramo] = resto;
    return `Ramo ${ramo.join(':')} (${nomeProduto(produto)})`;
  }
  return alvo;
}
